import styled from 'styled-components'

const StyledCoursePreviewContent = styled.div`
  .course-content-container {
    margin-top: 24px;
    overflow: hidden;
  }
`

export default StyledCoursePreviewContent
